import {
  InputBaseComponentProps,
  TextField,
  TextFieldProps,
} from '@mui/material';
import React, { RefObject } from 'react';
import { IMaskInput } from 'react-imask';

type PhoneNumberMaskProps = InputBaseComponentProps & {
  onChange: (event: { target: { name: string; value: string } }) => void;
  unmask?: boolean;
  name: string;
};

const PhoneNumberMask = React.forwardRef<HTMLElement, PhoneNumberMaskProps>(
  (props, ref) => {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask={[{ mask: '(000) 000-0000' }]}
        inputRef={ref as RefObject<HTMLInputElement>}
        onAccept={(value: string) => {
          onChange({ target: { name: props.name, value } });
        }}
        overwrite
      />
    );
  }
);

type PhoneNumberFieldProps = Omit<
  TextFieldProps,
  'inputComponent' | 'InputProps'
> &
  PhoneNumberMaskProps;

export const PhoneNumberField: React.FC<PhoneNumberFieldProps> = ({
  unmask,
  ...props
}) => {
  return (
    <TextField
      {...props}
      InputProps={{
        inputComponent: PhoneNumberMask,
        inputProps: { unmask },
      }}
    />
  );
};

export default PhoneNumberField;
